/* assets/custom-upsell-carousel.js */

/*
 * Upsell carousel add-to-cart.
 *
 * Uses a single document-level (delegated) submit listener instead of binding
 * to each form on init. This is important for the CART DRAWER: the drawer's
 * inner HTML is replaced on every add / quantity change / removal, which would
 * destroy any per-form listeners. Delegation survives those re-renders.
 *
 * Config (button texts, redirect, cart type) is read at submit time from the
 * closest [data-custom-upsell-carousel] ancestor, so each carousel keeps its
 * own settings.
 */

(function () {
  'use strict';

  function root() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function config(rootEl) {
    var d = (rootEl && rootEl.dataset) || {};
    return {
      defaultText: d.buttonText || 'До кошика',
      loadingText: d.loadingText || 'Додаємо...',
      successText: d.successText || 'Додано',
      errorText: d.errorText || 'Не вдалося додати',
      redirectToCart: d.redirectToCart === 'true',
      cartType: d.cartType || 'drawer'
    };
  }

  function getSectionsToRender() {
    var sections = [];
    if (document.querySelector('cart-drawer')) sections.push('cart-drawer');
    if (document.querySelector('cart-notification')) sections.push('cart-notification');
    if (document.querySelector('#cart-icon-bubble')) sections.push('cart-icon-bubble');
    return sections;
  }

  function updateCartUI(data) {
    if (!data.sections) return;

    Object.keys(data.sections).forEach(function (sectionId) {
      var html = data.sections[sectionId];
      if (!html) return;

      var doc = new DOMParser().parseFromString(html, 'text/html');

      if (sectionId === 'cart-icon-bubble') {
        var bubble = document.querySelector('#cart-icon-bubble');
        var freshBubble = doc.querySelector('#shopify-section-cart-icon-bubble');
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }

      if (sectionId === 'cart-drawer') {
        var drawer = document.querySelector('cart-drawer');
        var freshDrawer = doc.querySelector('cart-drawer');
        if (drawer && freshDrawer) drawer.innerHTML = freshDrawer.innerHTML;
      }

      if (sectionId === 'cart-notification') {
        var notification = document.querySelector('cart-notification');
        var freshNotification = doc.querySelector('cart-notification');
        if (notification && freshNotification) notification.innerHTML = freshNotification.innerHTML;
      }
    });
  }

  function openCart(cfg) {
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    if (drawer) {
      drawer.classList.add('active', 'animate');
      drawer.classList.remove('is-empty');
      return;
    }

    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') {
      notification.open();
      return;
    }

    if (cfg.cartType === 'page') {
      window.location.href = root() + 'cart';
    }
  }

  function setButtonState(cfg, button, label, state) {
    if (state === 'default') {
      button.removeAttribute('data-state');
      if (label) label.textContent = cfg.defaultText;
      return;
    }
    button.dataset.state = state;
    if (label) {
      if (state === 'loading') label.textContent = cfg.loadingText;
      if (state === 'success') label.textContent = cfg.successText;
    }
  }

  function showError(errorBox, message) {
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function hideError(errorBox) {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  async function addToCart(form) {
    var rootEl = form.closest('[data-custom-upsell-carousel]');
    var cfg = config(rootEl);

    var button = form.querySelector('[data-custom-upsell-carousel-button]');
    var label = form.querySelector('[data-custom-upsell-carousel-label]');
    var errorBox = form.querySelector('[data-custom-upsell-carousel-error]');

    if (!button || button.disabled || button.dataset.busy === 'true') return;

    button.dataset.busy = 'true';
    hideError(errorBox);
    setButtonState(cfg, button, label, 'loading');

    var formData = new FormData(form);
    var sections = getSectionsToRender();

    if (sections.length) {
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    try {
      var response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      var data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || cfg.errorText);
      }

      updateCartUI(data);
      setButtonState(cfg, button, label, 'success');

      if (cfg.redirectToCart) {
        window.location.href = root() + 'cart';
        return;
      }

      openCart(cfg);

      // Note: button may have been replaced by the drawer re-render above;
      // resetting it is a best-effort no-op in that case.
      window.setTimeout(function () {
        if (document.body.contains(button)) {
          setButtonState(cfg, button, label, 'default');
          button.dataset.busy = 'false';
        }
      }, 1600);
    } catch (error) {
      setButtonState(cfg, button, label, 'default');
      showError(errorBox, error.message || cfg.errorText);
      button.dataset.busy = 'false';
    }
  }

  // Single delegated submit listener — survives drawer/section re-renders.
  if (!window.__customUpsellCarouselBound) {
    window.__customUpsellCarouselBound = true;

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target.closest('[data-custom-upsell-carousel-form]');
        if (!form) return;
        if (!form.closest('[data-custom-upsell-carousel]')) return;
        event.preventDefault();
        addToCart(form);
      },
      true
    );
  }
})();
